import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
  selector: 'app-custom-dropdown',
  templateUrl: './custom-dropdown.component.html',
  styleUrls: ['./custom-dropdown.component.scss']
})
export class CustomDropdownComponent implements OnInit {


  @Input() buttonLabel: string;
  @Input() buttonIcon: string;
  @Input() headerTitle: string;
  @Input() headerIcon: string;
  @Input() dropdownItems: [{label:any; icon?: string; img?:any}];

  @Output() submitEvent = new EventEmitter<any>();

  constructor() {}
  
  ngOnInit(): void {
  }

}
